// extracted by mini-css-extract-plugin
export default {"phoneInput":"phoneInput_phoneInput__pE9l7","select_element":"phoneInput_select_element__be1eO"};